import React from 'react';
import { Box } from '@amzn/awsui-components-react-v3';

import { NavigationDropdown } from 'components';
import './SectionHeader.scss';

/**
 *
 * @param {actions} React.Component Extra components to render on the right side that would be like buttons
 * @returns
 */
const SectionHeader = ({ title, variant = 'h2', tagOverride, actions, suppressNav = false }) => {
    return (
        <div data-testid="section-header">
            <Box variant={variant} data-testid="section-subheader" tagOverride={tagOverride}>
                {title}
            </Box>
            {!suppressNav && (
                <div>
                    {actions}
                    <NavigationDropdown />
                </div>
            )}
        </div>
    );
};

export default SectionHeader;
